"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailingListType = void 0;
var MailingListType;
(function (MailingListType) {
    MailingListType["SIGNUP_LIST"] = "SIGNUP_LIST";
})(MailingListType = exports.MailingListType || (exports.MailingListType = {}));
